import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type PaginatedResults } from "shared/api/types/pagination";
import { type SocietyParamsInput } from "shared/api/types/society/[societyId]";
import {
  type SocietyFileAPIPathOutput,
  type SocietyFilePostBodyInput,
  type SocietyFileInfoOutput,
} from "shared/api/types/society/[societyId]/files/index";
import { type FileView } from "shared/mappers/database/files/file";
export const getSocietyFilesContract: BaseApiContract<
  SocietyParamsInput,
  undefined,
  PaginatedResults<FileView, SocietyFileAPIPathOutput>
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/files",
  paramsType: {} as SocietyParamsInput,
  responseType: {} as PaginatedResults<FileView, SocietyFileAPIPathOutput>,
};
export const postSocietyFilesContract: BaseApiContract<
  SocietyParamsInput,
  SocietyFilePostBodyInput,
  SocietyFileInfoOutput
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/files",
  paramsType: {} as SocietyParamsInput,
  bodyType: {} as SocietyFilePostBodyInput,
  responseType: {} as SocietyFileInfoOutput,
};
export const putSocietyFilesContract: BaseApiContract<
  SocietyParamsInput,
  SocietyFilePostBodyInput,
  SocietyFileInfoOutput
> = {
  method: HttpMethod.PUT,
  apiRoute: "/api/v1/society/[societyId]/files",
  paramsType: {} as SocietyParamsInput,
  bodyType: {} as SocietyFilePostBodyInput,
  responseType: {} as SocietyFileInfoOutput,
};
